import {Component, inject} from "@angular/core";
import {Router} from "@angular/router";

@Component({
  selector: 'admin-onboarding-payment-processing',
  templateUrl: './admin-onboarding-payment-processing.page.html',
  styleUrls: ['./admin-onboarding-payment-processing.page.scss']
})
export class AdminOnboardingPaymentProcessingPage {
  readonly #router = inject(Router);

  leave() {
    this.#router.navigate(["/app"])
  }

}
